import { fontSize } from '@baseapp-frontend/design-system-mui'

export const typography = {
  display: {
    fontSize: fontSize(84),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 700,
    letterSpacing: fontSize(-2.5),
    lineHeight: '100%',
  },
  displaySm: {
    fontSize: fontSize(72),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 700,
    letterSpacing: fontSize(-1.5),
    lineHeight: '100%',
  },
  h1: {
    fontSize: fontSize(70),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(-2),
    lineHeight: '110%',
  },
  h2: {
    fontSize: fontSize(48),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(-1),
    lineHeight: '120%',
  },
  h3: {
    fontSize: fontSize(36),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(0),
    lineHeight: '110%',
  },
  h35: {
    fontSize: fontSize(32),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(0),
    lineHeight: '110%',
  },
  h4: {
    fontSize: fontSize(30),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(0),
    lineHeight: '110%',
  },
  h5: {
    fontSize: fontSize(24),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(0),
    lineHeight: '110%',
  },
  h6: {
    fontSize: fontSize(20),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(0),
    lineHeight: '120%',
  },
  h7: {
    fontSize: fontSize(20),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(0),
    lineHeight: '120%',
  },
  subtitle1: {
    fontSize: fontSize(18),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 400,
    letterSpacing: fontSize(0),
    lineHeight: '129%',
  },
  subtitle2: {
    fontSize: fontSize(16),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(0),
    lineHeight: '129%',
  },
  subtitle3: {
    fontSize: fontSize(18),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(0),
    lineHeight: '130%',
  },
  body1: {
    fontSize: fontSize(16),
    fontFamily: 'GeneralSans, sans-serif',
    letterSpacing: fontSize(0),
    lineHeight: '129%',
  },
  body2: {
    fontSize: fontSize(16),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(0),
    lineHeight: '139%',
  },
  button: {
    fontSize: fontSize(16),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(0),
    lineHeight: '100%',
  },
  button2: {
    fontSize: fontSize(16),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(0),
    lineHeight: '129%',
  },
  caption: {
    fontSize: fontSize(14),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 500,
    letterSpacing: fontSize(0.5),
    lineHeight: '129%',
  },
  overline: {
    fontSize: fontSize(10),
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    letterSpacing: fontSize(2),
    lineHeight: '129%',
  },
  title: {
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 600,
    fontSize: fontSize(70),
    lineHeight: '110%',
    letterSpacing: '-2px',
  },
  titleBold: {
    fontFamily: 'GeneralSans, sans-serif',
    fontWeight: 700,
    fontSize: fontSize(70),
    lineHeight: '110%',
    letterSpacing: '-2px',
  },
  landingHero: {
    fontFamily: 'SortsMillGoudy, sans-serif',
    fontWeight: 400,
    fontSize: fontSize(64),
    lineHeight: '110%',
    letterSpacing: '-2px',
  },
}
